import { TrackingCard } from "./TrackingCard";

export default TrackingCard;
